export const getUrlVars = (qString) => {
    var vars = [],
        hash
    var hashes = qString.slice(qString.indexOf('?') + 1).split('&')
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=')
        // vars.push(hash[0]);
        vars[hash[0]] = hash[1]
    }
    return vars
}
